<!-- 全部评论 -->
<template>
  <van-popup v-model="show" round position="bottom" z-index="999999999">
    <div class="allComments-window">
      <div class="allComments-window-top">
        全部评论
        <button type="button" class="allComments-window-close" @click="show = false">
          <img src="../assets/icon-106.png" alt="">
        </button>
      </div>
    </div>

    <div class="comment-list-fixed-height">
      <comments
      :switchShow="true"
      :type="type"
          v-if="show"
          ref="comments"
          :switch-val="switchVal"
          :fixed-list-height="true"
          @switchChange="switchChange"
          @append="$emit('append', $event)"
          @delComment="$emit('delComment', $event)"
          @likeComment="$emit('likeComment', $event)"
      />
    </div>

    <div class="allComments-window-bottom" @click="$refs.comments.commentPostShow()">
      <div class="allComments-window-input-box">
        <input class="allComments-window-input" placeholder="发布一条友善的评论" disabled/>
      </div>
      <button type="button" class="allComments-window-bottom-btn">发布</button>
    </div>
  </van-popup>
</template>

<script>
import Comments from "@/components/comments.vue";

export default {
  name: 'comments-popup',
  components: {Comments},
  props: {
    switchVal: {
      default: 0,
    },
    switchShow:{
default:true
    },
     type: {
      default: '',
    },
  },
  watch: {
    switchVal() {
      this.checked = this.switchVal;
    },
  },
  data() {
    return {
      checked: 0,
      show: false,
    };
  },
  methods: {
    switchChange(){
      this.$emit('switchChange', 1)
    },
    showFn(option) {
      this.show = true;
      this.$nextTick(() => {
        this.$refs.comments.init({
          ...option,
          fixedListHeight: true,
        });
      });
    },
  }
}
</script>

<style scoped>
.allComments-window {
  width: 100%;
  padding: 0 12px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.allComments-window-top {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 0 0;
  margin-bottom: 4px;
  color: #222222;
  font-size: 18px;
  font-weight: bold;
  position: relative;
}

.allComments-window-close {
  position: absolute;
  right: 0;
  top: 18px
}

.allComments-window-close > img {
  width: 18px;
}

.allComments-window-bottom {
  width: 100%;
  height: 83px;
  padding-top: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
}

.allComments-window-input-box {
  flex: 1;
  margin-left: 12px;
  background-color: #F3F3F3;
  height: 36px;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 50px;
}

.allComments-window-input {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  border-radius: 50px;
  pointer-events: none;
}

.allComments-window-input::placeholder {
  color: #999999;
}

.allComments-window-bottom-btn {
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  font-size: 16px;
  font-weight: bold;
  color: #2A63F3;
}

.comment-list-fixed-height {
  height: calc(100vh - 250px + 39px);
  overflow: hidden;
}
</style>
